/**
 * @enum {Direction}
 */
export const WORD_DIRECTIONS = {
  EAST: { deg: 0, x: 1, y: 0 },
  NORTH: { deg: 90, x: 0, y: -1 },
  WEST: { deg: 180, x: -1, y: 0 },
  SOUTH: { deg: 270, x: 0, y: 1 },
  NORTH_EAST: { deg: 45, x: 1, y: -1 },
  NORTH_WEST: { deg: 90 + 45, x: -1, y: -1 },
  SOUTH_WEST: { deg: 180 + 45, x: -1, y: 1 },
  SOUTH_EAST: { deg: 270 + 45, x: 1, y: 1 },
  NEUTRAL: { deg: -1, x: 0, y: 0 },
  E: { deg: 0, x: 1, y: 0 },
  N: { deg: 90, x: 0, y: -1 },
  O: { deg: 180, x: -1, y: 0 },
  S: { deg: 270, x: 0, y: 1 },
  NE: { deg: 45, x: 1, y: -1 },
  NO: { deg: 90 + 45, x: -1, y: -1 },
  SO: { deg: 180 + 45, x: -1, y: 1 },
  SE: { deg: 270 + 45, x: 1, y: 1 },
};

/**
 * Constantes de sonidos para SOPA - Mapeados desde la versión V2 Phaser
 */
export const SOPA_SOUNDS = {
  MOUSE_HOVER: "mouse-hover",           
  CARGAR_LETRA: "carga-letra",          
  MOVER_LETRA: "mover-letra",           
  
  LETRA_OK: "letra-ok",               
  LETRA_ERROR: "letra-error",         
  CORRECT_WORD: "correct-word",       
};
